import { Button } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { PageRoutes } from '../../../../constants/routes';
import { primaryColor } from '../../../../constants/theme';

export const ProfileButton = ({
  userId,
  width,
  bookingId,
  overrideText,
}: {
  userId: string;
  width: number | string;
  bookingId: number;
  overrideText?: string;
}) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate(`${PageRoutes.PROFILE}?professionalId=${userId}`);
  };

  const text = overrideText || 'Profile';

  return (
    <Button
      radius="md"
      variant="outline"
      color={primaryColor}
      leftSection={<IconUser size={16} />}
      w={width}
      onClick={onClick}
      data-testid={`profile-button-${bookingId}`}
    >
      {text}
    </Button>
  );
};
